import { render, staticRenderFns } from "./MailTemplatesView.vue?vue&type=template&id=358de9cd&"
import script from "./MailTemplatesView.vue?vue&type=script&lang=js&"
export * from "./MailTemplatesView.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplatesView.vue?vue&type=style&index=0&id=358de9cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports